const ArrowDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_141_17188)">
        <path
          d="M13.0698 18.8971L23.5572 8.55807C24.1476 7.97367 24.1476 7.0237 23.5572 6.4393C22.9668 5.8534 22.0079 5.8534 21.4175 6.4393L12.0001 15.7235L2.58261 6.4393C1.99222 5.8534 1.03329 5.8534 0.442909 6.4393C-0.147472 7.0252 -0.147472 7.97367 0.442909 8.55807L10.9303 18.8956C11.498 19.4604 12.5004 19.4619 13.0698 18.8971Z"
          fill="#E0E0E0"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_17188">
          <rect width="24" height="24" fill="white" transform="translate(24) rotate(90)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowDown;
